<template>
    <div class="main-content-container container-fluid px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4 ">
            <div class="col-12 text-center text-sm-left mb-0 flex-header">
                <h3 class="page-title">Raporty</h3>
                <d-button theme="success" :class="{isLoading: exporting_report}" @click.prevent="downloadReport"><i class="material-icons">save_alt</i> Pobierz raport</d-button>
            </div>
        </div>

        <!-- Default Light Table -->
        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <div class="card card-small" v-if="fetched">
                <div class="card-header border-bottom flex-header">
                    <div class="search-wrapper">
                        <d-input-group>
                            <ss-autocomplete @optionSelected="optionSelectedHanlder"
                                             :placeholder="'Spółka'"
                                             :options="allCompanies"
                                             :value="search.company_id.toString()" />
                            <d-select type="text"
                                      name="overdue_payments"
                                      id="select-overdue"
                                      v-model="search.overdue_payments">
                                <option value="0">--Płatności</option>
                                <option value="1">Tylko zaległe</option>
                                <option value="3">Tylko otwarte</option>
                                <option value="2">Sprawy w egzakucji</option>
                                <option value="0">Wszystkie</option>
                            </d-select>
                            <ss-date placeholder="Data"
                                     name="date"
                                     v-model="search.date"
                                     title="Wyliczenia raportów na wybrany dzień" />
                            <button class="button btn autocomplete-clear btn-secondary" @click.prevent="clearAutocomplete">Wyczyść</button>
                        </d-input-group>
                    </div>
                </div>
                <status-legend class="border-bottom"></status-legend>
                <div class="card-body p-0 pb-3 text-center">
                    <table class="table mb-0 responsive-table vam">
                        <thead class="bg-light">
                        <tr>
                            <th scope="col" class="border-0">Klient</th>
                            <th scope="col" class="border-0">Kwota pożyczki</th>
                            <th scope="col" class="border-0">Prowizja</th>
                            <th scope="col" class="border-0">Odsetki</th>
                            <th scope="col" class="border-0">Kwoty</th>
                            <th scope="col" class="border-0">Najbliższa rata</th>
                            <th scope="col" class="border-0">Data końca umowy</th>
                            <th scope="col" class="border-0">Telefon</th>
                            <th scope="col" class="border-0">Akcje</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(schedule, index) in schedules"
                            :key="'raport-' + index"
                            class="relative-row"
                            :class="[{ 'bg-light-red' : installmentDue(schedule)}, { 'is-archive' : schedule.is_archive !== 0}, { 'archive-accepted' : schedule.is_archive === 1}, { 'bg-green' : schedule.finalized === 1}]">
                            <td class="relative-cell">
                                <ss-popover  v-if="schedule.is_terminated === 1" variant="right" class="terminated-info">
                                    <template slot="tooltip">Umowa wypowiedziana</template>
                                </ss-popover>
                                <span class="status-border" :style="[{ 'backgroundColor' : borderColorFromStatus(schedule.status) }]"></span>
                                <dt>Klient</dt>
                                <dd>
                                    <template v-if="schedule.company_type === 'buisness_activity'">
                                    <a href="#" @click.prevent="$router.push({ name: 'client-edit', params: { id: schedule.client_id }})">
                                        {{ schedule.client_name }} {{ schedule.client_last_name }}
                                    </a>
                                    </template>
                                    <template v-if="schedule.company_type === 'corporation'">
                                        {{ schedule.client_name }}
                                    </template>
                                </dd>
                            </td>

                            <td>
                                <dt>Kwota pożyczki</dt>
                                <dd>

                                    <span class="wsnw">{{ toNumber(schedule.loan_amount) }} zł</span>
                                </dd>
                            </td>
                            <td>
                                <dt>Prowizja</dt>
                                <dd><span class="wsnw">{{ toNumber(schedule.installment_sum) }} zł</span></dd>
                            </td>
                            <td>
                                <dt>Odsetki</dt>
                                <dd><span class="wsnw">{{ toNumber(schedule.interest_sum) }} zł</span></dd>
                            </td>
                            <td>
                                <dt>Kwoty</dt>
                                <dd>
                                    <span class="wsnw"><strong>Wpłacona:</strong> {{ toNumber(schedule.current_amount_paid) }} zł</span><br />
                                    <span class="wsnw"><strong>Zaległa:</strong> {{ toNumber(schedule.current_overdue_installments_sum) }} zł</span>
                                    <ss-popover>
                                        ({{ schedule.current_overdue_installments_number }})
                                        <template slot="tooltip">Ilość zaległych rat</template>
                                    </ss-popover>

                                </dd>
                            </td>
                            <td>
                                <dt>Najbliższa rata</dt>
                                <dd>
                                    <span class="wsnw"><strong>Kwota:</strong> {{ schedule.next_installment ? toNumber(schedule.next_installment) + ' zł' : '-' }}</span><br />
                                    <span class="wsnw"><strong>Data:</strong> {{ schedule.next_installment_payment_date ? schedule.next_installment_payment_date : '-' }}</span>
                                </dd>
                            </td>
                            <td>
                                <dt>Data końca umowy</dt>
                                <dd>{{ schedule.finish_date }}</dd>
                            </td>
                            <td>
                                <dt>Telefon do pożyczkobiorcy</dt>
                                <dd>{{ schedule.client_phone }}</dd>
                            </td>
                            <td>
                                <dt>Akcje</dt>
                                <dd><d-button @click="editSchedule(schedule)"><i class="material-icons">edit</i> Edytuj</d-button></dd>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p v-if="schedules &&  schedules.length < 1" class="text-info">Brak umów do wyświetlenia.</p>
                    <ss-pagination v-if="last_page > 1"
                                   @paginationChange="paginationChangeHandler"
                                   :current_page="current_page" :last_page="last_page" />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import FileSaver from 'file-saver'
    import { mapGetters, mapActions } from 'vuex'
    import SsAutocomplete from '../components/common/SsAutocomplete'
    import StatusLegend from '../components/common/StatusLegend'
    import ColorUtils from '../utils/colors';
    import clientUtils from '../utils/client';
    import SsPagination from '../components/common/SsPagination'
    import SsDate from '../components/common/SsDate'

    export default {
        name: "Raports",
        components: {
            SsAutocomplete,
            clientUtils,
            StatusLegend,
            SsPagination,
            SsDate
        },
        data(){
            return{
                client: '',
                fetched: false,
                current_page: 1,
                last_page: 1,
                statuses: [],
                exporting_report: false,
                search: {
                    name: '',
                    surname: '',
                    email: '',
                    company_id: '',
                    phone: '',
                    overdue_payments: '0',
                    date: Vue.getCurrentDate()
                },
                schedules: [],
                client_id: null
            }
        },
        computed:{
            ...mapGetters([
                'allCompanies'
            ])
        },
        methods: {
            ...mapActions([
                'getAllCompanies'
            ]),
            downloadReport(){
                this.exporting_report = true;
                axios.post('api/reports/download-reports-file',
                    {
                        search: this.search,
                        date: this.search.date
                    },
                    {responseType: 'blob'}).then(response => {
                    let blob = new File(
                        [response.data],
                        'raport_' +  (this.search.date || Vue.getCurrentDate()) + '.xlsx'
                    );
                    FileSaver.saveAs(blob);
                    this.exporting_report = false;
                }).catch(error=>{
                    this.exporting_report = false;
                })
            },
            paginationChangeHandler(page){
                this.current_page = page;
                this.loadSchedules();
            },
            installmentDue(schedule){
                return schedule.current_overdue_installments_number > 0;
            },
            clearAutocomplete(){
                this.search = {
                    name: '',
                    surname: '',
                    email: '',
                    company_id: '',
                    phone: '',
                    overdue_payments: '0',
                    date: Vue.getCurrentDate()
                };
                this.$forceUpdate();
            },
            optionSelectedHanlder(company_id){
                this.search.company_id = company_id;
            },
            toNumber(number){
                return Vue.toNumber(number)
            },
            fetchData(){
                this.getAllCompanies();
                this.loadSchedules();
            },
            borderColorFromStatus(status){
                return status ? ColorUtils.status[status] : 'transparent';
            },
            loadSchedules: _.debounce(function(){
                axios.post('api/reports/get-reports', {
                    page: this.current_page,
                    search: this.search,
                    date: this.search.date
                }).then(response => {
                    this.schedules = response.data.schedules;
                    this.last_page = response.data.last_page ? response.data.last_page : 1;
                    this.current_page = response.data.current_page ? response.data.current_page : 1;

                    this.fetched = true;
                }).catch((errors) =>{
                    console.log(errors);
                    this.fetched = true;
                })
            }, 500),
            editSchedule(schedule){
                this.$router.push({name: 'contract-edit', params: {client_id: schedule.client_id, schedule_id: schedule.schedule_id, from: 'raports'}})
            },
            exportInvoiceToPdf(id, type){
                this['exporting_' + type] = true;
                axios.post('api/invoices/download-invoice?date=' + Date.now(),
                    {
                        invoice_id: id
                    },
                    {responseType: 'blob'}).then(response => {
                    let blob = new File(
                        [response.data],
                        this.clientById(this.schedule.client_id).replace(' ', '_') + '_faktura_' + (type === 'interest' ? 'koncowa' : 'prowizyjna') + '_' +  Vue.getCurrentDate() + '.pdf',
                        { type: 'application/pdf' }
                    );
                    FileSaver.saveAs(blob);
                    this['exporting_' + type] = false;
                }).catch(error=>{
                    this['exporting_' + type] = false;
                })
            },
        },
        mounted(){
            this.statuses = clientUtils._statuses;
            this.fetchData();
        },
        watch: {
            client_id(to){
                this.loadSchedules(to);
            },
            search: {
                handler: function(to) {
                    this.loadSchedules();
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss">
    #select-overdue{
        width: 200px;
    }
    .search-wrapper .form-control{
        min-width: 200px;
    }
    table.table.responsive-table.vam{
        strong{
            font-weight: bold;
        }
    }
</style>
